import * as React from "react";
import { useTryInStoreContext } from "../../context/context/context.js";
import { useProducts } from "./use-products.js";
const getProductBySku = (productList, sku) => {
  return productList?.find((product) => product.sku === sku);
};
const useTryInStore = () => {
  const [tryInStoreStorage, storageHandlers] = useTryInStoreContext();
  const [getProducts, { data, called, error }] = useProducts();
  const products = React.useMemo(() => {
    return tryInStoreStorage?.map((storageItem) => {
      const product = getProductBySku(data, storageItem.sku);
      if (product) {
        return {
          ...product,
          __itemType: "product"
        };
      }
      if (called && data && !product) {
        return {
          ...storageItem,
          __itemType: "notFound"
        };
      }
      return {
        ...storageItem,
        __itemType: "storage"
      };
    }) ?? [];
  }, [tryInStoreStorage, data, called]);
  const fetchProducts = React.useCallback(() => {
    const skus = tryInStoreStorage?.map(({ sku }) => sku);
    if (skus) {
      getProducts(skus);
    }
  }, [getProducts, tryInStoreStorage]);
  const state = React.useMemo(
    () => ({
      error,
      products: error ? null : products,
      itemCount: products.length ?? 0
    }),
    [error, products]
  );
  const handlers = React.useMemo(
    () => ({
      fetchProducts,
      storage: storageHandlers
    }),
    [fetchProducts, storageHandlers]
  );
  return [state, handlers];
};
export {
  useTryInStore
};
//# sourceMappingURL=use-try-in-store.js.map
